import React from 'react'
import { Tooltip } from 'react-tooltip'
import { connect } from 'react-redux'

import IconPlus from './plus'
import IconPlusChunky from './plusChunky'
import IconArrowDownSmall from './arrowDownSmall'
import IconBell from './bell'
import ArrowDown from './arrowDown'
import ArrowUp from './arrowUp'
import ArrowRight from './arrowRight'
import ArrowLeft from './arrowLeft'
import ArrowLeftSmall from './arrowLeftSmall'
import DoubleArrowUp from './doubleArrowUp'
import ArrowGraphUp from './arrowGraphUp'
import Help from './help'
import QuestionCircle from './questionCircle'
import Document from './document'
import Calendar from './calendar'
import List from './list'
import MergeTags from './mergeTags'
import Envelope from './envelope'
import Lightning from './lightning'
import CopyClipboard from './copyClipboard'
import CopyClipboardOutline from './copyClipboardOutline'
import Grid from './grid'
import Tick from './tick'
import Share from './share'
import Cog from './cog'
import Cross from './cross'
import CrossChunky from './crossChunky'
import Magnifier from './magnifier'
import Circle from './circle'
import CircleSolid from './circleSolid'
import Bin from './bin'
import Image from './image'
import ImageOutline from './imageOutline'
import NewWindow from './newWindow'
import World from './world'
import Star from './star'
import StarNew from './starNew'
import StarSolid from './starSolid'
import Pencil from './pencil'
import Upload from './upload'
import Facebook from './facebook'
import Warning from './warning'
import Twitter from './twitter'
import Instagram from './instagram'
import LinkedIn from './linkedin'
import YouTube from './youtube'
import Rss from './rss'
import HandPointingUp from './handPointingUp'
import Folder from './folder'
import Wand from './wand'
import ArrowSelect from './arrowSelect'
import Split from './split'
import TickCircle from './tickCircle'
import Mobile from './mobile'
import Alert from './alert'
import AlertOutline from './alertOutline'
import Outbox from './outbox'
import PersonAdd from './personAdd'
import Template from './template'
import Stack from './stack'
import Capsule from './capsule'
import Pc from './pc'
import Avatars3 from './avatars3'
import Tablet from './tablet'
import Smiley from './smiley'
import CrossCircle from './crossCircle'
import DotsVertical from './dotsVertical'
import Money from './money'
import ShoppingBag from './shoppingbag'
import Undo from './undo'
import Eye from './eye'
import MoveIcon from './move'
import Loading from './loading'
import LifeRing from './lifeRing'
import Code from './code'
import LineArrowDown from './lineArrowDown'
import LineArrowRight from './lineArrowRight'
import AlignLeft from './alignLeft'
import AlignCenter from './alignCenter'
import AlignRight from './alignRight'
import AlignTop from './alignTop'
import AlignMiddle from './alignMiddle'
import AlignBottom from './alignBottom'
import AlignStretch from './alignStretch'
import JustifyContentStart from './justifyContentStart'
import JustifyContentCenter from './justifyContentCenter'
import JustifyContentEnd from './justifyContentEnd'
import Person from './person'
import PersonOutline from './personOutline'
import People from './people'
import Switch from './switch'
import Avatars2 from './avatars2'
import Tag from './tag'
import TagOutline from './tagOutline'
import Filter from './filter'
import Office from './office'
import Swatch from './swatch'
import Sparkle from './sparkle'
import Sparkle2 from './sparkle2'
import Sparkle3 from './sparkle3'
import SparkleGradient from './sparkleGradient'
import Organisations from './organisations'
import Sms from './sms'
import Integrations from './integrations'
import Globe from './globe'
import Megaphone from './megaphone'
import External from './external'
import ExternalBold from './externalBold'
import Logout from './logout'
import Pinterest from './pinterest'
import ZoomIn from './zoomIn'
import ZoomOut from './zoomOut'
import Clock from './clock'
import Download from './download'
import Download3 from './download3'
import BranchDown from './branchDown'
import Transaction from './transaction'
import ArrowsUpDown from './arrowsUpDown'
import Medal from './medal'
import ArrowBounce from './arrowBounce'
import EnvelopeOpen from './envelopeOpen'
import Text from './text'
import Divider from './divider'
import Button from './button'
import Heart from './heart'
import Chart from './chart'
import Input from './input'
import Select from './select'
import HiddenInput from './hiddenInput'
import RadioButton from './radioButton'
import TextArea from './textarea'
import TextBlock from './textBlock'
import Captcha from './captcha'
import CheckBox from './checkbox'
import Cake from './cake'
import Wave from './wave'
import Bookmark from './bookmark'
import Floppydisk from './floppydisk'
import ShieldTick from './shieldTick'
import ShieldTickOutline from './shieldTickOutline'
import Menu from './menu'
import CloudUpload from './cloudUpload'
import CloudDownload from './cloudDownload'
import Expand from './expand'
import Contract from './contract'
import ThumbsUp from './thumbsUp'
import ThumbsDown from './thumbsDown'
import Reply from './reply'
import Surveillance from './surveillance'
import History from './history'
import ChevronLeft from './chevronLeft'
import ChevronRight from './chevronRight'
import ChevronDown from './chevronDown'
import ChevronUp from './chevronUp'
import ChevronsUp from './chevronsUp'
import Link from './link'
import Palette from './palette'
import TikTok from './tikTok'
import Save from './save'
import TickCircleDouble from './tickCircleDouble'
import Chat from './chat'
import Beaker from './beaker'
import Table from './table'
import Exclude from './exclude'
import CircleThin from './circleThin'
import PaperPlane from './paperPlane'
import Drag from './drag'
import Video from './video'
import Info from './info'
import TickBreakingCircle from './tickBreakingCircle'
import QuestionCircleOutline from './questionCircleOutline'
import BookOpen from './bookOpen'
import Rabbit from './rabbit'
import Inbox from './inbox'
import Padlock from './padlock'
import None from './none'
import LandingPage from './landingPage'
// icons that use their own colors unless disabled
import InstagramColor from './instagramColor'
import XColor from './xColor'
import LinkedInColor from './linkedinColor'
import FacebookColor from './facebookColor'
import FacebookColorRounded from './facebookColorRounded'
import PInterestColorRounded from './pinterestColorRounded'
import XColorRounded from './xColorRounded'
import LinkedInColorRounded from './linkedInColorRounded'
import InstagramColorRounded from './instagramColorRounded'
import IconsPlay from './play'
import IconsPaused from './paused'
import UpgradeChevrons from './upgradeChevrons'
import PaperPlaneOutline from './paperPlaneOutline'
import EnvelopeOutlineTick from './envelopeOutlineTick'
import PointerClick from './pointerClick'
import Redo from './redo'
import IconsArrowUpAlternative from './arrowUpAlternative'
import IconsArrowDownAlternative from './arrowDownAlternative'
import IconsAIWand from './aiWand'

// icons for segment operators
import Contains from './contains'
import DoesNotContain from './doesNotContain'
import DoesNotEndWith from './doesNotEndWith'
import DoesNotStartWith from './doesNotStartWith'
import EndsWith from './endsWith'
import Equals from './equals'
import IsBlank from './isBlank'
import IsNotBlank from './isNotBlank'
import NotEquals from './notEquals'
import StartsWith from './startsWith'
import Between from './between'
import Clicked from './clicked'
import GreaterThan from './greaterThan'
import GreaterThanOrEquals from './greaterThanOrEquals'
import LessThan from './lessThan'
import LessThanOrEquals from './lessThanOrEquals'
import NotClicked from './notClicked'
import StarRatingIs from './starRatingIs'
import TickCircleGreen from './tickCircleGreen'
import DocumentUpload from './documentUpload'
import BrandAnalyser from './brandAnalyser'
import IconsTemplateOutline from './templateOutline'
import IconsEmailAddOutline from './emailAddOutline'
import LightningOutline from './lightningOutline'
import PersonAddOutline from './personAddOutline'
import EnvelopeTick from './envelopeTick'
import Logo123Reg from './logo-123reg'
import LogoAmazonRoute53 from './logo-amazonroute53'
import LogoArSys from './logo-arsys'
import LogoBluehost from './logo-bluehost'
import LogoCloudflare from './logo-cloudflare'
import LogoDigitalOcean from './logo-digitalocean'
import LogoDreamhost from './logo-dreamhost'
import LogoGoogledomains from './logo-googledomains'
import LogoGreengeeks from './logo-greengeeks'
import LogoHostgater from './logo-hostgater'
import LogoHostinger from './logo-hostinger'
import LogoHover from './logo-hover'
import LogoInhosting from './logo-inhosting'
import LogoIonos from './logo-ionos'
import LogoNamecheap from './logo-namecheap'
import LogoHeartinternet from './logo-heartinternet'
import LogoSiteground from './logo-siteground'
import LogoInmotion from './logo-inmotion'
import GenericDomain from './genericDomain'
import ArrowLeftLight from './arrowLeftLight'
import Monitor from './monitor'
import MobileOutline from './mobileOutline'
import PlusCircle from './plusCircle'
import Clone from './clone'
import BinOutline from './binOutline'

import MarginBottom from './marginBottom'
import MarginLeft from './marginLeft'
import MarginLeftRight from './marginLeftRight'
import MarginRight from './marginRight'
import MarginTop from './marginTop'
import MarginTopBottom from './marginTopBottom'

import PaddingBottom from './paddingBottom'
import PaddingLeft from './paddingLeft'
import PaddingLeftRight from './paddingLeftRight'
import PaddingRight from './paddingRight'
import PaddingTop from './paddingTop'
import PaddingTopBottom from './paddingTopBottom'
import PaddingExpander from './paddingExpander'

import BorderRadiusAll from './borderRadiusAll'
import BorderRadiusTopLeft from './borderRadiusTopLeft'
import BorderRadiusTopRight from './borderRadiusTopRight'
import BorderRadiusBottomLeft from './borderRadiusBottomLeft'
import BorderRadiusBottomRight from './borderRadiusBottomRight'

import IconsEdit from './edit'
import IconsReplace from './replace'
import IconsDesktopMobile from './desktopMobile'
import IconsDesktop from './desktop'
import IconsMobileNew from './mobileNew'
import IconEllipsis from './ellipsis'

import IconsDnDInput from './DnDInput'
import IconsDnDForm from './DnDForm'
import IconsDnDSubmit from './DnDSubmit'
import IconsDnDText from './DnDText'
import IconsDnDImage from './DnDImage'
import IconsDnDErrorMessageHolder from './DnDErrorMessageHolder'
import IconsDnDCheckBox from './DnDCheckBox'
import IconsDnDSelect from './DnDSelect'
import IconsDnDRadioButtons from './DnDRadioButtons'
import IconsDnDYouTubeVideo from './DnDYouTubeVideo'
import IconsDnDTextArea from './DnDTextArea'
import IconsDnDHiddenInput from './DnDHiddenInput'
import IconsDnDCaptcha from './DnDCaptcha'
import IconsDnDGatedContent from './DnDGatedContent'

import IconsMainNavAbSplit from './mainNavAbSplit'
import IconsMainNavAccountSettings from './mainNavAccountSettings'
import IconsMainNavAddContact from './mainNavAddContact'
import IconsMainNavAds from './mainNavAds'
import IconsMainNavAllCampaigns from './mainNavAllCampaigns'
import IconsMainNavAllContacts from './mainNavAllContacts'
import IconsMainNavApiDocs from './mainNavApiDocs'
import IconsMainNavAutomation from './mainNavAutomation'
import IconsMainNavBilling from './mainNavBilling'
import IconsMainNavCompanySwitcher from './mainNavCompanySwitcher'
import IconsMainNavDenyList from './mainNavDenyList'
import IconsMainNavEarlyAccessFeatures from './mainNavEarlyAccessFeatures'
import IconsMainNavEmail from './mainNavEmail'
import IconsMainNavForms from './mainNavForms'
import IconsMainNavGettingStarted from './mainNavGettingStarted'
import IconsMainNavGroups from './mainNavGroups'
import IconsMainNavHelp from './mainNavHelp'
import IconsMainNavIntegrations from './mainNavIntegrations'
import IconsMainNavLandingPages from './mainNavLandingPages'
import IconsMainNavListCleaner from './mainNavListCleaner'
import IconsMainNavLogout from './mainNavLogout'
import IconsMainNavPreferences from './mainNavPreferences'
import IconsMainNavResell from './mainNavResell'
import IconsMainNavSegments from './mainNavSegments'
import IconsMainNavSms from './mainNavSms'
import IconsMainNavSocial from './mainNavSocial'
import IconsMainNavTemplates from './mainNavTemplates'
import IconsMainNavTransactions from './mainNavTransactions'
import IconsMainNavTracking from './mainNavTracking'
import IconsMainNavWhatsNew from './mainNavWhatsNew'
import TabletOutline from './tabletOutline'
import IconsGoal from './goal'
import IconsLineChart from './lineChart'
import IconsCalendarCheck from './calendarCheck'
import IconsDocumentDownload from './documentDownload'
import IconsMegaphoneOutline from './megaphoneOutline'
import IconLpNavMenu from './lpNavMenu'

@connect((store) => {
    return {
        siteMaster: store.siteMaster
    }
})
export default class Icons extends React.Component {
    constructor(props) {
        super(props)
        this.iconRef = React.createRef()
    }

    componentDidMount() {
        // Set CSS variables for site colors on document root
        if (this.props.siteMaster.colours) {
            Object.keys(this.props.siteMaster.colours).forEach((key) => {
                const colorKey = key.replace('$', '--site-')
                document.documentElement.style.setProperty(colorKey, this.props.siteMaster.colours[key])
            })
        }

        if (this.iconRef.current && this.props.className?.indexOf('icons-cross') > -1) {
            // update the var for the color of the cross to be the input the color
            this.iconRef.current.style.setProperty(
                '--icon-color',
                this.props.color || this.props.siteMaster.colours['$primary']
            )
        }
    }

    componentDidUpdate() {
        // Update CSS variables when site colors change
        if (this.props.siteMaster.colours) {
            Object.keys(this.props.siteMaster.colours).forEach((key) => {
                const colorKey = key.replace('$', '--site-')
                document.documentElement.style.setProperty(colorKey, this.props.siteMaster.colours[key])
            })
        }

        if (this.iconRef.current && this.props.className?.indexOf('icons-cross') > -1) {
            // update the var for the color of the cross to be the input the color
            this.iconRef.current.style.setProperty(
                '--icon-color',
                this.props.color || this.props.siteMaster.colours['$primary']
            )
        }
    }

    render() {
        let icon = undefined
        // Use CSS variable instead of direct access
        let color = this.props.color || 'var(--site-primary)'

        let style = {}
        if (this.props.style) style = JSON.parse(JSON.stringify(this.props.style))
        if (this.props.onClick) style.cursor = 'pointer'

        let className = 'icons-holder'
        // Lets an icon stay hidden until the row or block it sits in is hovered. See app.css.
        if (this.props.showOnHover) className += ' show-on-hover'
        if (this.props.className) className += ' ' + this.props.className

        let outerStyle = { ...style }
        // outerStyle.display = 'flex'
        if (this.props.circle) {
            outerStyle.borderRadius = '50%'
            let backgroundColor = color && color.indexOf('#') === 0 ? `${hexToRgbA(color, 0.2)}` : 'transparent'
            if (color.indexOf('var(') === 0) {
                // grab value from the css var and light that by 20%
                const temp = window
                    .getComputedStyle(document.documentElement)
                    .getPropertyValue(color.replace('var(', '').replace(')', ''))
                    .trim()
                backgroundColor = `${hexToRgbA(temp, 0.2)}`
            }
            outerStyle.backgroundColor = backgroundColor
            outerStyle.padding = 5
            outerStyle.display = 'flex'
            outerStyle.justifyContent = 'center'
            outerStyle.alignItems = 'center'
            if (!outerStyle.height) {
                outerStyle.height = 30
            }
            if (!outerStyle.width) {
                outerStyle.width = 30
            }
        }
        if (this.props.square) {
            outerStyle.borderRadius = '4px'
            let backgroundColor = color && color.indexOf('#') === 0 ? `${hexToRgbA(color, 0.2)}` : 'transparent'
            if (color.indexOf('var(') === 0) {
                // grab value from the css var and light that by 20%
                const temp = window
                    .getComputedStyle(document.documentElement)
                    .getPropertyValue(color.replace('var(', '').replace(')', ''))
                    .trim()
                backgroundColor = `${hexToRgbA(temp, 0.2)}`
            }
            outerStyle.backgroundColor = backgroundColor
            outerStyle.padding = 5
            outerStyle.display = 'flex'
            outerStyle.justifyContent = 'center'
            outerStyle.alignItems = 'center'
        }

        if (this.props.disabled) {
            outerStyle.opacity = 0.5
            outerStyle.cursor = 'not-allowed'
        }
        outerStyle = { ...outerStyle, ...this.props.outerStyle }

        switch (this.props.icon) {
            case 'plus':
                icon = <IconPlus color={color} style={style} />
                break
            case 'plusChunky':
                icon = <IconPlusChunky color={color} style={style} />
                break
            case 'smallArrowDown':
                icon = <IconArrowDownSmall color={color} style={style} />
                break
            case 'arrowGraphUp':
                icon = <ArrowGraphUp color={color} style={style} />
                break
            case 'bell':
                icon = <IconBell color={color} style={style} />
                break
            case 'arrowUp':
                icon = <ArrowUp color={color} style={style} />
                break
            case 'arrowDown':
                icon = <ArrowDown color={color} style={style} />
                break
            case 'arrowRight':
                icon = <ArrowRight color={color} style={style} />
                break
            case 'arrowLeft':
                icon = <ArrowLeft color={color} style={style} />
                break
            case 'arrowLeftSmall':
                icon = <ArrowLeftSmall color={color} style={style} />
                break
            case 'doubleArrowUp':
                icon = <DoubleArrowUp color={color} style={style} />
                break
            case 'help':
                icon = <Help color={color} style={style} />
                break
            case 'questionCircle':
                icon = <QuestionCircle color={color} style={style} />
                break
            case 'document':
                icon = <Document color={color} style={style} />
                break
            case 'calendar':
                icon = <Calendar color={color} style={style} />
                break
            case 'list':
                icon = <List color={color} style={style} />
                break
            case 'mergeTags':
                icon = <MergeTags color={color} style={style} />
                break
            case 'envelope':
                icon = <Envelope color={color} style={style} />
                break
            case 'lightning':
                icon = <Lightning color={color} style={style} />
                break
            case 'copyClipboard':
                icon = <CopyClipboard color={color} style={style} />
                break
            case 'copyClipboardOutline':
                icon = <CopyClipboardOutline color={color} style={style} />
                break
            case 'grid':
                icon = <Grid color={color} style={style} />
                break
            case 'checkbox':
                icon = <CheckBox color={color} style={style} />
                break
            case 'tick':
                icon = <Tick color={color} style={style} />
                break
            case 'share':
                icon = <Share color={color} style={style} />
                break
            case 'cog':
                icon = <Cog color={color} style={style} />
                break
            case 'cross':
                icon = <Cross color={color} style={style} />
                break
            case 'crossChunky':
                icon = <CrossChunky color={color} style={style} />
                break
            case 'magnifier':
                icon = <Magnifier color={color} style={style} />
                break
            case 'circle':
                icon = <Circle color={color} style={style} />
                break
            case 'circleSolid':
                icon = <CircleSolid color={color} style={style} />
                break
            case 'bin':
                icon = <Bin color={color} style={style} />
                break
            case 'image':
                icon = <Image color={color} style={style} />
                break
            case 'imageOutline':
                icon = <ImageOutline color={color} style={style} />
                break
            case 'newWindow':
                icon = <NewWindow color={color} style={style} />
                break
            case 'world':
                icon = <World color={color} style={style} />
                break
            case 'star':
                icon = <Star color={color} style={style} />
                break
            case 'starNew':
                icon = <StarNew color={color} style={style} />
                break
            case 'starSolid':
                icon = <StarSolid color={color} style={style} />
                break
            case 'pencil':
                icon = <Pencil color={color} style={style} />
                break
            case 'upload':
                icon = <Upload color={color} style={style} />
                break
            case 'facebook':
                icon = <Facebook color={color} style={style} />
                break
            case 'errormessageholder':
            case 'warning':
                icon = <Warning color={color} style={style} />
                break
            case 'twitter':
                icon = <Twitter color={color} style={style} />
                break
            case 'instagram':
                icon = <Instagram color={color} style={style} />
                break
            case 'linkedin':
                icon = <LinkedIn color={color} style={style} />
                break
            case 'youtubevideo':
            case 'dndyoutubevideo':
            case 'youtube':
                icon = <IconsDnDYouTubeVideo color={color} style={style} />
                break
            case 'tikTok':
                icon = <TikTok color={color} style={style} />
                break
            case 'rssfeed':
            case 'rss':
                icon = <Rss color={color} style={style} />
                break
            case 'submit':
            case 'handPointingUp':
                icon = <HandPointingUp color={color} style={style} />
                break
            case 'folder':
                icon = <Folder color={color} style={style} />
                break
            case 'wand':
                icon = <Wand color={color} style={style} />
                break
            case 'arrowSelect':
                icon = <ArrowSelect color={color} style={style} />
                break
            case 'split':
                icon = <Split color={color} style={style} />
                break
            case 'tickCircle':
                icon = <TickCircle color={color} style={style} />
                break
            case 'tickCircleDouble':
                icon = <TickCircleDouble color={color} style={style} />
                break
            case 'mobile':
                icon = <Mobile color={color} style={style} />
                break
            case 'alert':
                icon = <Alert color={color} style={style} />
                break
            case 'alertOutline':
                icon = <AlertOutline color={color} style={style} />
                break
            case 'outbox':
                icon = <Outbox color={color} style={style} />
                break
            case 'personAdd':
                icon = <PersonAdd color={color} style={style} />
                break
            case 'template':
                icon = <Template color={color} style={style} />
                break
            case 'stack':
                icon = <Stack color={color} style={style} />
                break
            case 'capsule':
                icon = <Capsule color={color} style={style} />
                break
            case 'pc':
                icon = <Pc color={color} style={style} />
                break
            case 'avatars3':
                icon = <Avatars3 color={color} style={style} />
                break
            case 'tablet':
                icon = <Tablet color={color} style={style} />
                break
            case 'tabletOutline':
                icon = <TabletOutline color={color} style={style} />
                break
            case 'smiley':
                icon = <Smiley color={color} style={style} />
                break
            case 'crossCircle':
                icon = <CrossCircle color={color} style={style} />
                break
            case 'dotsVertical':
                icon = <DotsVertical color={color} style={style} />
                break
            case 'money':
                icon = <Money color={color} style={style} />
                break
            case 'shoppingbag':
                icon = <ShoppingBag color={color} style={style} />
                break
            case 'undo':
                icon = <Undo color={color} style={style} />
                break
            case 'eye':
                icon = <Eye color={color} style={style} />
                break
            case 'move':
                icon = <MoveIcon color={color} style={style} />
                break
            case 'loading':
                icon = <Loading color={color} style={style} />
                break
            case 'lifering':
                icon = <LifeRing color={color} style={style} />
                break
            case 'customhtml':
            case 'code':
                icon = <Code color={color} style={style} />
                break
            case 'lineArrowDown':
                icon = <LineArrowDown color={color} style={style} />
                break
            case 'lineArrowRight':
                icon = <LineArrowRight color={color} style={style} />
                break
            case 'alignLeft':
                icon = <AlignLeft color={color} style={style} />
                break
            case 'alignRight':
                icon = <AlignRight color={color} style={style} />
                break
            case 'alignCenter':
                icon = <AlignCenter color={color} style={style} />
                break
            case 'alignTop':
                icon = <AlignTop color={color} style={style} />
                break
            case 'alignMiddle':
                icon = <AlignMiddle color={color} style={style} />
                break
            case 'alignBottom':
                icon = <AlignBottom color={color} style={style} />
                break
            case 'alignStretch':
                icon = <AlignStretch color={color} style={style} />
                break
            case 'justifyContentStart':
                icon = <JustifyContentStart color={color} style={style} />
                break
            case 'justifyContentCenter':
                icon = <JustifyContentCenter color={color} style={style} />
                break
            case 'justifyContentEnd':
                icon = <JustifyContentEnd color={color} style={style} />
                break
            case 'person':
                icon = <Person color={color} style={style} />
                break
            case 'personOutline':
                icon = <PersonOutline color={color} style={style} />
                break
            case 'people':
                icon = <People color={color} style={style} />
                break
            case 'switch':
                icon = <Switch color={color} style={style} />
                break
            case 'avatars2':
                icon = <Avatars2 color={color} style={style} />
                break
            case 'tag':
                icon = <Tag color={color} style={style} />
                break
            case 'tagOutline':
                icon = <TagOutline color={color} style={style} />
                break
            case 'filter':
                icon = <Filter color={color} style={style} />
                break
            case 'office':
                icon = <Office color={color} style={style} />
                break
            case 'swatch':
                icon = <Swatch color={color} style={style} />
                break
            case 'sparkle':
                icon = <Sparkle color={color} style={style} />
                break
            case 'sparkle2':
                icon = <Sparkle2 color={color} style={style} />
                break
            case 'sparkle3':
                icon = <Sparkle3 color={color} style={style} />
                break
            case 'sparkleGradient':
                icon = <SparkleGradient style={style} />
                break
            case 'organisations':
                icon = <Organisations color={color} style={style} />
                break
            case 'sms':
                icon = <Sms color={color} style={style} />
                break
            case 'integrations':
                icon = <Integrations color={color} style={style} />
                break
            case 'globe':
                icon = <Globe color={color} style={style} />
                break
            case 'megaphone':
                icon = <Megaphone color={color} style={style} />
                break
            case 'external':
                icon = <External color={color} style={style} />
                break
            case 'externalBold':
                icon = <ExternalBold color={color} style={style} />
                break
            case 'logout':
                icon = <Logout color={color} style={style} />
                break
            case 'pinterest':
                icon = <Pinterest color={color} style={style} />
                break
            case 'zoomIn':
                icon = <ZoomIn color={color} style={style} />
                break
            case 'zoomOut':
                icon = <ZoomOut color={color} style={style} />
                break
            case 'countdown':
            case 'clock':
                icon = <Clock color={color} style={style} />
                break
            case 'download':
                icon = <Download color={color} style={style} />
                break
            case 'download3':
                icon = <Download3 color={color} style={style} />
                break
            case 'branchDown':
                icon = <BranchDown color={color} style={style} />
                break
            case 'transaction':
                icon = <Transaction color={color} style={style} />
                break
            case 'arrowsUpDown':
                icon = <ArrowsUpDown color={color} style={style} />
                break
            case 'medal':
                icon = <Medal color={color} style={style} />
                break
            case 'arrowBounce':
                icon = <ArrowBounce color={color} style={style} />
                break
            case 'envelopeOpen':
                icon = <EnvelopeOpen color={color} style={style} />
                break
            case 'text':
                icon = <Text color={color} style={style} />
                break
            case 'divider':
                icon = <Divider color={color} style={style} />
                break
            case 'button':
                icon = <Button color={color} style={style} />
                break
            case 'socialmediaicons':
            case 'heart':
                icon = <Heart color={color} style={style} />
                break
            case 'chart':
            case 'poll':
                icon = <Chart color={color} style={style} />
                break
            case 'input':
                icon = <Input color={color} style={style} />
                break
            case 'select':
                icon = <Select color={color} style={style} />
                break
            case 'hiddeninput':
                icon = <HiddenInput color={color} style={style} />
                break
            case 'radiobuttons':
            case 'radiobutton':
                icon = <RadioButton color={color} style={style} />
                break
            case 'textarea':
                icon = <TextArea color={color} style={style} />
                break
            case 'textBlock':
                icon = <TextBlock color={color} style={style} />
                break
            case 'captcha':
                icon = <Captcha color={color} style={style} />
                break
            case 'cake':
                icon = <Cake color={color} style={style} />
                break
            case 'wave':
                icon = <Wave color={color} style={style} />
                break
            case 'bookmark':
                icon = <Bookmark color={color} style={style} />
                break
            case 'floppydisk':
                icon = <Floppydisk color={color} style={style} />
                break
            case 'shieldtick':
                icon = <ShieldTick color={color} style={style} />
                break
            case 'shieldtickOutline':
                icon = <ShieldTickOutline color={color} style={style} />
                break
            case 'menu':
                icon = <Menu color={color} style={style} />
                break
            case 'cloudUpload':
                icon = <CloudUpload color={color} style={style} />
                break
            case 'cloudDownload':
                icon = <CloudDownload color={color} style={style} />
                break
            case 'expand':
                icon = <Expand color={color} style={style} />
                break
            case 'contract':
                icon = <Contract color={color} style={style} />
                break
            case 'thumbsUp':
                icon = <ThumbsUp color={color} style={style} />
                break
            case 'thumbsDown':
                icon = <ThumbsDown color={color} style={style} />
                break
            case 'reply':
                icon = <Reply color={color} style={style} />
                break
            case 'surveillance':
                icon = <Surveillance color={color} style={style} />
                break
            case 'history':
                icon = <History color={color} style={style} />
                break
            case 'chevronLeft':
                icon = <ChevronLeft color={color} style={style} />
                break
            case 'chevronRight':
                icon = <ChevronRight color={color} style={style} />
                break
            case 'chevronDown':
                icon = <ChevronDown color={color} style={style} />
                break
            case 'chevronUp':
                icon = <ChevronUp color={color} style={style} />
                break
            case 'chevronsUp':
                icon = <ChevronsUp color={color} style={style} />
                break
            case 'link':
                icon = <Link color={color} style={style} />
                break
            case 'palette':
                icon = <Palette color={color} style={style} />
                break
            case 'gatedcontent':
            case 'save':
                icon = <Save color={color} style={style} />
                break
            case 'chat':
                icon = <Chat color={color} style={style} />
                break
            case 'beaker':
                icon = <Beaker color={color} style={style} />
                break
            case 'table':
                icon = <Table color={color} style={style} />
                break
            case 'exclude':
                icon = <Exclude color={color} style={style} />
                break
            case 'circleThin':
                icon = <CircleThin color={color} style={style} />
                break
            case 'paperPlane':
                icon = <PaperPlane color={color} style={style} />
                break
            case 'video':
                icon = <Video color={color} style={style} />
                break
            case 'info':
                icon = <Info color={color} style={style} />
                break
            case 'questionCircleOutline':
                icon = <QuestionCircleOutline color={color} style={style} />
                break
            case 'bookOpen':
                icon = <BookOpen color={color} style={style} />
                break
            case 'inbox':
                icon = <Inbox color={color} style={style} />
                break

            case 'instagramColor':
                icon = <InstagramColor color={this.props.disabled ? '#B5BAC0' : ''} style={style} />
                break
            case 'xColor':
                icon = <XColor color={this.props.disabled ? '#B5BAC0' : ''} style={style} />
                break
            case 'linkedinColor':
                icon = <LinkedInColor color={this.props.disabled ? '#B5BAC0' : ''} style={style} />
                break
            case 'facebookColor':
                icon = <FacebookColor color={this.props.disabled ? '#B5BAC0' : ''} style={style} />
                break
            case 'beaker':
                icon = <Beaker color={color} style={style} />
                break
            case 'drag':
                icon = <Drag color={color} style={style} />
                break
            case 'facebookColorRounded':
                icon = <FacebookColorRounded color={color} style={style} />
                break
            case 'pinterestColorRounded':
                icon = <PInterestColorRounded color={color} style={style} />
                break
            case 'xColorRounded':
                icon = <XColorRounded color={color} style={style} />
                break
            case 'linkedInColorRounded':
                icon = <LinkedInColorRounded color={color} style={style} />
                break
            case 'instagramColorRounded':
                icon = <InstagramColorRounded color={color} style={style} />
                break
            case 'play':
                icon = <IconsPlay color={color} style={style} />
                break
            case 'paused':
                icon = <IconsPaused color={color} style={style} />
                break
            case 'contains':
                icon = <Contains color={color} style={style} />
                break
            case 'doesNotContain':
                icon = <DoesNotContain color={color} style={style} />
                break
            case 'doesNotEndWith':
                icon = <DoesNotEndWith color={color} style={style} />
                break
            case 'doesNotStartWith':
                icon = <DoesNotStartWith color={color} style={style} />
                break
            case 'endsWith':
                icon = <EndsWith color={color} style={style} />
                break
            case 'equals':
                icon = <Equals color={color} style={style} />
                break
            case 'isBlank':
                icon = <IsBlank color={color} style={style} />
                break
            case 'isNotBlank':
                icon = <IsNotBlank color={color} style={style} />
                break
            case 'notEquals':
                icon = <NotEquals color={color} style={style} />
                break
            case 'startsWith':
                icon = <StartsWith color={color} style={style} />
                break
            case 'between':
                icon = <Between color={color} style={style} />
                break
            case 'clicked':
                icon = <Clicked color={color} style={style} />
                break
            case 'greaterThanOrEquals':
                icon = <GreaterThanOrEquals color={color} style={style} />
                break
            case 'greaterThan':
                icon = <GreaterThan color={color} style={style} />
                break
            case 'lessThan':
                icon = <LessThan color={color} style={style} />
                break
            case 'lessThanOrEquals':
                icon = <LessThanOrEquals color={color} style={style} />
                break
            case 'notClicked':
                icon = <NotClicked color={color} style={style} />
                break
            case 'starRatingIs':
                icon = <StarRatingIs color={color} style={style} />
                break
            case 'upgradeChevrons':
                icon = <UpgradeChevrons color={color} style={style} />
                break
            case 'rabbit':
                icon = <Rabbit color={color} style={style} />
                break
            case 'tickCircleGreen':
                icon = <TickCircleGreen style={style} />
                break
            case 'documentUpload':
                icon = <DocumentUpload color={color} style={style} />
                break
            case 'brandAnalyser':
                icon = <BrandAnalyser color={color} style={style} />
                break
            case 'templateOutline':
                icon = <IconsTemplateOutline color={color} style={style} />
                break
            case 'emailAddOutline':
                icon = <IconsEmailAddOutline color={color} style={style} />
                break
            case 'lightningOutline':
                icon = <LightningOutline color={color} style={style} />
                break
            case 'personAddOutline':
                icon = <PersonAddOutline color={color} style={style} />
                break
            case 'envelopeTick':
                icon = <EnvelopeTick color={color} style={style} />
            case 'tickBreakingCircle':
                icon = <TickBreakingCircle color={color} style={style} />
                break
            case 'paperPlaneOutline':
                icon = <PaperPlaneOutline color={color} style={style} />
                break
            case 'envelopeOutlineTick':
                icon = <EnvelopeOutlineTick color={color} style={style} />
                break
            case 'pointerClick':
                icon = <PointerClick color={color} style={style} />
                break
            case 'logo123reg':
                icon = <Logo123Reg color={color} style={style} />
                break
            case 'logoAmazonRoute53':
                icon = <LogoAmazonRoute53 color={color} style={style} />
                break
            case 'logoArSys':
                icon = <LogoArSys color={color} style={style} />
                break
            case 'logoBluehost':
                icon = <LogoBluehost color={color} style={style} />
                break
            case 'logoCloudflare':
                icon = <LogoCloudflare color={color} style={style} />
                break
            case 'logoDigitalOcean':
                icon = <LogoDigitalOcean color={color} style={style} />
                break
            case 'logoDreamhost':
                icon = <LogoDreamhost color={color} style={style} />
                break
            case 'logoGoogledomains':
                icon = <LogoGoogledomains color={color} style={style} />
                break
            case 'logoGreengeeks':
                icon = <LogoGreengeeks color={color} style={style} />
                break
            case 'logoHostgater':
                icon = <LogoHostgater color={color} style={style} />
                break
            case 'logoHostinger':
                icon = <LogoHostinger color={color} style={style} />
                break
            case 'logoHover':
                icon = <LogoHover color={color} style={style} />
                break
            case 'logoInhosting':
                icon = <LogoInhosting color={color} style={style} />
                break
            case 'logoIonos':
                icon = <LogoIonos color={color} style={style} />
                break
            case 'logoNamecheap':
                icon = <LogoNamecheap color={color} style={style} />
                break
            case 'logoHeartinternet':
                icon = <LogoHeartinternet color={color} style={style} />
                break
            case 'logoSiteground':
                icon = <LogoSiteground color={color} style={style} />
                break
            case 'logoInmotion':
                icon = <LogoInmotion color={color} style={style} />
                break
            case 'genericDomain':
                icon = <GenericDomain color={color} style={style} />
                break
            case 'arrowLeftLight':
                icon = <ArrowLeftLight color={color} style={style} />
                break

            case 'padlock':
                icon = <Padlock color={color} style={style} />
                break

            case 'monitor':
                icon = <Monitor color={color} style={style} />
                break
            case 'mobileOutline':
                icon = <MobileOutline color={color} style={style} />
                break
            case 'plusCircle':
                icon = <PlusCircle style={style} />
                break

            case 'marginBottom':
                icon = <MarginBottom color={color} style={style} />
                break
            case 'marginLeft':
                icon = <MarginLeft color={color} style={style} />
                break
            case 'marginLeftRight':
                icon = <MarginLeftRight color={color} style={style} />
                break
            case 'marginRight':
                icon = <MarginRight color={color} style={style} />
                break
            case 'marginTop':
                icon = <MarginTop color={color} style={style} />
                break
            case 'marginTopBottom':
                icon = <MarginTopBottom color={color} style={style} />
                break

            case 'paddingBottom':
                icon = <PaddingBottom color={color} style={style} />
                break
            case 'paddingLeft':
                icon = <PaddingLeft color={color} style={style} />
                break
            case 'paddingLeftRight':
                icon = <PaddingLeftRight color={color} style={style} />
                break
            case 'paddingRight':
                icon = <PaddingRight color={color} style={style} />
                break
            case 'paddingTop':
                icon = <PaddingTop color={color} style={style} />
                break
            case 'paddingTopBottom':
                icon = <PaddingTopBottom color={color} style={style} />
                break
            case 'paddingExpander':
                icon = <PaddingExpander color={color} style={style} />
                break

            case 'borderRadiusAll':
                icon = <BorderRadiusAll color={color} style={style} />
                break
            case 'borderRadiusTopLeft':
                icon = <BorderRadiusTopLeft color={color} style={style} />
                break
            case 'borderRadiusTopRight':
                icon = <BorderRadiusTopRight color={color} style={style} />
                break
            case 'borderRadiusBottomLeft':
                icon = <BorderRadiusBottomLeft color={color} style={style} />
                break
            case 'borderRadiusBottomRight':
                icon = <BorderRadiusBottomRight color={color} style={style} />
                break
            case 'redo':
                icon = <Redo color={color} style={style} />
                break
            case 'clone':
                icon = <Clone color={color} style={style} />
                break
            case 'binOutline':
                icon = <BinOutline color={color} style={style} />
                break
            case 'arrowUpAlternative':
                icon = <IconsArrowUpAlternative color={color} style={style} />
                break
            case 'arrowDownAlternative':
                icon = <IconsArrowDownAlternative color={color} style={style} />
                break
            case 'aiWand':
                icon = <IconsAIWand color={color} style={style} />
                break
            case 'edit':
                icon = <IconsEdit color={color} style={style} />
                break
            case 'replace':
                icon = <IconsReplace color={color} style={style} />
                break
            case 'desktopMobile':
                icon = <IconsDesktopMobile />
                break
            case 'desktop':
                icon = <IconsDesktop />
                break
            case 'mobileNew':
                icon = <IconsMobileNew />
                break
            case 'none':
                icon = <None color={color} style={style} />
                break
            case 'ellipsis':
                icon = <IconEllipsis style={style} />
                break

            case 'dndinput':
                icon = <IconsDnDInput color={color} style={style} />
                break
            case 'dndsubmit':
                icon = <IconsDnDSubmit color={color} style={style} />
                break
            case 'dndtext':
                icon = <IconsDnDText color={color} style={style} />
                break
            case 'dndimage':
                icon = <IconsDnDImage color={color} style={style} />
                break
            case 'dnderrormessageholder':
                icon = <IconsDnDErrorMessageHolder color={color} style={style} />
                break
            case 'dndcheckbox':
                icon = <IconsDnDCheckBox color={color} style={style} />
                break
            case 'dndselect':
                icon = <IconsDnDSelect color={color} style={style} />
                break
            case 'dndradiobuttons':
                icon = <IconsDnDRadioButtons color={color} style={style} />
                break
            case 'dndtextarea':
                icon = <IconsDnDTextArea color={color} style={style} />
                break
            case 'dndhiddeninput':
                icon = <IconsDnDHiddenInput color={color} style={style} />
                break
            case 'dndcaptcha':
                icon = <IconsDnDCaptcha color={color} style={style} />
                break
            case 'dndgatedcontent':
                icon = <IconsDnDGatedContent color={color} style={style} />
                break
            case 'dndform':
                icon = <IconsDnDForm color={color} style={style} />
                break
            case 'landingPage':
                icon = <LandingPage color={color} style={style} />
                break

            case 'mainNavAbSplit':
                icon = <IconsMainNavAbSplit color={color} style={style} />
                break
            case 'mainNavAccountSettings':
                icon = <IconsMainNavAccountSettings color={color} style={style} />
                break
            case 'mainNavAddContact':
                icon = <IconsMainNavAddContact color={color} style={style} />
                break
            case 'mainNavAds':
                icon = <IconsMainNavAds color={color} style={style} />
                break
            case 'mainNavAllCampaigns':
                icon = <IconsMainNavAllCampaigns color={color} style={style} />
                break
            case 'mainNavAllContacts':
                icon = <IconsMainNavAllContacts color={color} style={style} />
                break
            case 'mainNavApiDocs':
                icon = <IconsMainNavApiDocs color={color} style={style} />
                break
            case 'mainNavAutomation':
                icon = <IconsMainNavAutomation color={color} style={style} />
                break
            case 'mainNavBilling':
                icon = <IconsMainNavBilling color={color} style={style} />
                break
            case 'mainNavCompanySwitcher':
                icon = <IconsMainNavCompanySwitcher color={color} style={style} />
                break
            case 'mainNavDenyList':
                icon = <IconsMainNavDenyList color={color} style={style} />
                break
            case 'mainNavEarlyAccessFeatures':
                icon = <IconsMainNavEarlyAccessFeatures color={color} style={style} />
                break
            case 'mainNavEmail':
                icon = <IconsMainNavEmail color={color} style={style} />
                break
            case 'mainNavForms':
                icon = <IconsMainNavForms color={color} style={style} />
                break
            case 'mainNavGettingStarted':
                icon = <IconsMainNavGettingStarted color={color} style={style} />
                break
            case 'mainNavHelp':
                icon = <IconsMainNavHelp color={color} style={style} />
                break
            case 'mainNavGroups':
                icon = <IconsMainNavGroups color={color} style={style} />
                break
            case 'mainNavHelp':
                icon = <IconsMainNavHelp color={color} style={style} />
                break
            case 'mainNavIntegrations':
                icon = <IconsMainNavIntegrations color={color} style={style} />
                break
            case 'mainNavLandingPages':
                icon = <IconsMainNavLandingPages color={color} style={style} />
                break
            case 'mainNavListCleaner':
                icon = <IconsMainNavListCleaner color={color} style={style} />
                break
            case 'mainNavLogout':
                icon = <IconsMainNavLogout color={color} style={style} />
                break
            case 'mainNavPreferences':
                icon = <IconsMainNavPreferences color={color} style={style} />
                break
            case 'mainNavSegments':
                icon = <IconsMainNavSegments color={color} style={style} />
                break
            case 'mainNavListCleaner':
                icon = <IconsMainNavListCleaner color={color} style={style} />
                break
            case 'mainNavResell':
                icon = <IconsMainNavResell color={color} style={style} />
                break
            case 'mainNavSms':
                icon = <IconsMainNavSms color={color} style={style} />
                break
            case 'mainNavSocial':
                icon = <IconsMainNavSocial color={color} style={style} />
                break
            case 'mainNavTemplates':
                icon = <IconsMainNavTemplates color={color} style={style} />
                break
            case 'mainNavTracking':
                icon = <IconsMainNavTracking color={color} style={style} />
                break
            case 'mainNavTransactions':
                icon = <IconsMainNavTransactions color={color} style={style} />
                break
            case 'mainNavWhatsNew':
                icon = <IconsMainNavWhatsNew color={color} style={style} />
                break
            case 'goal':
                icon = <IconsGoal color={color} style={style} />
                break
            case 'lineChart':
                icon = <IconsLineChart color={color} style={style} />
                break
            case 'calendarCheck':
                icon = <IconsCalendarCheck color={color} style={style} />
                break
            case 'documentDownload':
                icon = <IconsDocumentDownload color={color} style={style} />
                break
            case 'megaphoneOutline':
                icon = <IconsMegaphoneOutline color={color} style={style} />
                break
            case 'lpNavMenu':
                icon = <IconLpNavMenu color={color} style={style} />
                break
            default:
                icon = ''
                break
        }

        if (!icon) return null
        if (this.props.svgOnly) {
            if (this.props['data-tooltip-content'] && this.props['data-tooltip-id']) {
                icon['data-tooltip-content'] = this.props['data-tooltip-content']
                icon['data-tooltip-id'] = this.props['data-tooltip-id']
                icon['data-tooltip-html'] = this.props['data-tooltip-html']
            }
            return icon
        }

        let RootTag = 'div'
        if (this.props.href) RootTag = 'a'

        return (
            <RootTag
                href={this.props.href}
                target={this.props.target}
                ref={this.iconRef}
                onClick={this.props.onClick}
                className={className}
                style={outerStyle}
                alt={this.props.alt}
                title={this.props.title}
                data-tooltip-content={this.props['data-tooltip-content']}
                data-tooltip-html={this.props['data-tooltip-html']}
                data-tooltip-id={this.props['data-tooltip-id']}
                data-ph={this.props.postHogTag || this.props['data-ph']}
            >
                {icon}
                {(this.props['data-tooltip-content'] || this.props['data-tooltip-html']) &&
                    this.props['data-tooltip-id'] && (
                        <Tooltip
                            id={this.props['data-tooltip-id']}
                            style={this.props['data-tooltip-style'] || undefined}
                            place={this.props['data-tooltip-position'] || undefined}
                        />
                    )}
            </RootTag>
        )
    }
}

function hexToRgbA(hex, opacity = 1) {
    var c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
    }
    throw new Error('Bad Hex')
}

export { ICON_NAMES } from './iconNames'
